import React, { useState } from "react";
import { Title } from "../../../../../stories/Title/Title";
import Close from "../../../../../images/Close.svg";
import { a11yProps } from "../../../../../styles/Tabs";
import { Tab, Tabs } from "@mui/material";
import LeftArrow from "../../../../../images/ArrowRight.svg";
import StockBalanceAdd from "../../purchase/stockbalance/StockBalanceAdd";
import { PageFor } from "../../../../../utils/Enum.types";
import { Button } from "../../../../../stories/Button/Button";
import useLabels from "../../../../../customHooks/useLabels";
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

const StockDetails = ({ setModalFlag }: Props) => {
  const [value, setValue] = useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const {companyLabel,subsidiaryLabel,itemLabel}=useLabels();
  return (
    <div className="maps-comp-details">
      <div className="maps-comp-details__title">
        <Title>{companyLabel}</Title>
        <img src={Close} alt="" onClick={() => setModalFlag(false)} />
      </div>
      <div className="maps-comp-details__tabs">
        <Tabs value={value} onChange={handleChange}>
          <Tab label={`${subsidiaryLabel} Wise`}value={0} {...a11yProps(0)} />

          <Tab label={`${itemLabel} Wise`} value={1} {...a11yProps(1)} />
        </Tabs>
      </div>
      <div className="maps-comp-details__tab-panel">
        <div className="maps-comp-details__tab-panel--top">
          <button>
            <img src={LeftArrow} alt="" />
            Back
          </button>
          <span>{subsidiaryLabel} Name</span>
        </div>

        <StockBalanceAdd pageType={PageFor.MODAL} />
      </div>
      <Button mode="cancel" onClick={() => setModalFlag(false)}/>
    </div>
  );
};

export default StockDetails;
